

/**
 * 通用js方法封装处理
 * Copyright (c) 2019 exseen
 */

// 日期格式化
export function parseTime(time, pattern) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    } else if (typeof time === 'string') {
      time = time.replace(new RegExp(/-/gm), '/').replace('T', ' ').replace(new RegExp(/\.[\d]{3}/gm), '');
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

// 表单重置
export function resetForm(refName) {
  if (this.$refs[refName]) {
    this.$refs[refName].resetFields();
  }
}

// 添加日期范围
export function addDateRange(params, dateRange, propName) {
  let search = params;
  search.params = typeof (search.params) === 'object' && search.params !== null && !Array.isArray(search.params) ? search.params : {};
  dateRange = Array.isArray(dateRange) ? dateRange : [];
  if (typeof (propName) === 'undefined') {
    search.params['beginTime'] = dateRange[0];
    search.params['endTime'] = dateRange[1];
  } else {
    search.params['begin' + propName] = dateRange[0];
    search.params['end' + propName] = dateRange[1];
  }
  return search;
}

// 回显数据字典
export function selectDictLabel(datas, value) {
  var actions = [];
  Object.keys(datas).some((key) => {
    if (datas[key].value == ('' + value)) {
      actions.push(datas[key].label);
      return true;
    }
  })
  return actions.join('');
}

// 回显数据字典（字符串数组）
export function selectDictLabels(datas, value, separator) {
  if(value === undefined) {
    return "";
  }
  var actions = [];
  var currentSeparator = undefined === separator ? "," : separator;
  var temp = value.split(currentSeparator);
  Object.keys(value.split(currentSeparator)).some((val) => {
    Object.keys(datas).some((key) => {
      if (datas[key].value == ('' + temp[val])) {
        actions.push(datas[key].label + currentSeparator);
      }
    })
  })
  return actions.join('').substring(0, actions.join('').length - 1);
}

// 字符串格式化(%s )
export function sprintf(str) {
  var args = arguments, flag = true, i = 1;
  str = str.replace(/%s/g, function () {
    var arg = args[i++];
    if (typeof arg === 'undefined') {
      flag = false;
      return '';
    }
    return arg;
  });
  return flag ? str : '';
}

// 转换字符串，undefined,null等转化为""
export function parseStrEmpty(str) {
  if (!str || str == "undefined" || str == "null") {
    return "";
  }
  return str;
}

// 数据合并
export function mergeRecursive(source, target) {
  for (var p in target) {
    try {
      if (target[p].constructor == Object) {
        source[p] = mergeRecursive(source[p], target[p]);
      } else {
        source[p] = target[p];
      }
    } catch (e) {
      source[p] = target[p];
    }
  }
  return source;
};

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 */
export function handleTree(data, id, parentId, children) {
  let config = {
    id: id || 'id',
    parentId: parentId || 'parentId',
    childrenList: children || 'children'
  };

  var childrenListMap = {};
  var nodeIds = {};
  var tree = [];

  for (let d of data) {
    let parentId = d[config.parentId];
    if (childrenListMap[parentId] == null) {
      childrenListMap[parentId] = [];
    }
    nodeIds[d[config.id]] = d;
    childrenListMap[parentId].push(d);
  }

  for (let d of data) {
    let parentId = d[config.parentId];
    if (nodeIds[parentId] == null) {
      tree.push(d);
    }
  }

  for (let t of tree) {
    adaptToChildrenList(t);
  }

  function adaptToChildrenList(o) {
    if (childrenListMap[o[config.id]] !== null) {
      o[config.childrenList] = childrenListMap[o[config.id]];
    }
    if (o[config.childrenList]) {
      for (let c of o[config.childrenList]) {
        adaptToChildrenList(c);
      }
    }
  }
  return tree;
}

/**
* 参数处理
* @param {*} params  参数
*/
export function tansParams(params) {
  let result = ''
  for (const propName of Object.keys(params)) {
    const value = params[propName];
    var part = encodeURIComponent(propName) + "=";
    if (value !== null && typeof (value) !== "undefined") {
      if (typeof value === 'object') {
        for (const key of Object.keys(value)) {
          if (value[key] !== null && typeof (value[key]) !== 'undefined') {
            let params = propName + '[' + key + ']';
            var subPart = encodeURIComponent(params) + "=";
            result += subPart + encodeURIComponent(value[key]) + "&";
          }
        }
      } else {
        result += part + encodeURIComponent(value) + "&";
      }
    }
  }
  return result
}

// 验证是否为blob格式
export async function blobValidate(data) {
  try {
    const text = await data.text();
    JSON.parse(text);
    return false;
  } catch (error) {
    return true;
  }
}


export function generateMenuArray(apiData){
  //递归函数，用于遍历和提取所需字段
  function extractFields(data) {
    return data.map(item => {
      const extractedItem = {
        path: item.path,
        menuName: item.menuName
      };
      // 如果当前项有子项，递归处理子项
      if (item.children) {
        extractedItem.children = extractFields(item.children);
      }
      return extractedItem;
    })
    //.filter(item => item.path !== null); // 过滤掉 path 为 null 的项
  }
  // 提取所需字段并生成新的数组
  return extractFields(apiData);
 
}

export function generateDisplayRoutes(localRoutes, apiData){
  console.log("localRoutes--", localRoutes,JSON.stringify(apiData))
  // 递归函数，用于过滤本地路由数组
  function filterRoutes(localRoutes, apiPaths) {
    return localRoutes.map(localRoute => {
      // 检查当前路由的路径是否在接口返回的路径中
      const apiRoute = apiPaths.find(apiPath => {
        return apiPath.path === localRoute.id});
      if (apiRoute) {
        const filteredRoute = {
          ...localRoute,
          children: localRoute.children ? filterRoutes(localRoute.children, apiRoute.children || []) : []
        };
        return filteredRoute;
      } else {
        return null;
      }
    }).filter(route => route !== null);
  }

  // 生成新的显示路由数组
  return filterRoutes(localRoutes, apiData);
}



export function formattedDate(timestamp){
  // 期望输出：yyyy-mm-dd hh:mm
  if (!timestamp) return '';

  // 使用同文件内的 parseTime 以处理多种输入类型
  try {
    const str = parseTime(timestamp, '{y}-{m}-{d} {h}:{i}');
    return str || '';
  } catch (e) {
    // 兜底：如果 parseTime 出错，尝试原始 Date 解析
    const d = new Date(timestamp);
    if (isNaN(d.getTime())) return '';
    const pad = (n) => (n < 10 ? '0' + n : n);
    return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }
}


export function formatNumberWithCommas(number) {
  if (number === null || number === undefined) {
    return '';
  }

  // 判断输入是否为字符串，如果是则尝试转换为数字
  if (typeof number === 'string') {
    // 如果字符串已经包含逗号，直接返回原字符串
    if (number.includes(',')) {
      return number;
    }
    number = parseFloat(number);
    // 如果转换失败，返回原字符串
    if (isNaN(number)) {
      return number;
    }
  }

  // 判断数字是否为负数
  const isNegative = number < 0;
  // 取绝对值并保留两位小数
  const absNumber = Math.abs(number).toFixed(2);

  // 将数字转换为字符串并分割整数部分和小数部分
  const [integerPart, decimalPart] = absNumber.split('.');

  // 使用正则表达式在整数部分插入逗号
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // 拼接整数部分和小数部分
  const formattedNumber = `${formattedInteger}.${decimalPart}`;

  // 如果原数字为负数，则在结果前加上负号
  return isNegative ? `-${formattedNumber}` : formattedNumber;
}